import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  filterLoading: false,
  filters: {},
  qrCode: {
    open: false,
    content: {}
  },
  vehicleDetails: {
    columns: [],
    headers: "",
    dataSource: [],
    totalCars: 0,
    config: {}
  },
  appliedFiltersDetail: {},
  dateFilter: null,
  URL: "",
  searchText: "",
  pagination: { pageSize: 10, currentPage: 1 },
  sortOrder: 1,
  isActive: "ACTIVE",
  criterias: []
};

const fetchTableDataStart = (state) => ({
  ...state,
  loading: true
});

const fetchTableDataSuccess = (state, action) => ({
  ...state,
  loading: false,
  vehicleDetails: {
    columns: action.data.columns,
    headers: action.data.headerText,
    dataSource: action.data.dataSource,
    totalCars: action.data.totalCars,
    config: action.data.config || {}
  },
  pagination: {
    ...state.pagination
  }
});

const fetchVehicleFilterStart = (state) => ({
  ...state,
  filterLoading: true
});

const fetchVehicleFilterFail = (state) => ({
  ...state,
  filterLoading: false
});

const fetchVehicleFilterSuccess = (state, action) => ({
  ...state,
  filterLoading: false,
  filters: action.data
});

const fetchTableDataFail = (state) => ({
  ...state,
  loading: false
});

const setUrl = (state, action) => ({
  ...state,
  URL: action.data
});

const setQRCode = (state, action) => ({
  ...state,
  qrCode: {
    open: action.data.open,
    content: action.data.content
  }
});

const setFilters = (state, action) => ({
  ...state,
  appliedFiltersDetail: action.filters,
  criterias: action.criterias
});

const setSearch = (state, action) => ({
  ...state,
  searchText: action.text
});

const setActive = (state, action) => ({
  ...state,
  isActive: action.value
});

const setSortOrder = (state, action) => ({
  ...state,
  sortOrder: +action.value
});

const setCurrentPage = (state, action) => ({
  ...state,
  pagination: { pageSize: 10, currentPage: action.page }
});

const vehiclePageReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_HOME_DATA_TABLE_START:
      return fetchTableDataStart(state, action);

    case actionTypes.GET_HOME_DATA_TABLE_SUCCESS:
      return fetchTableDataSuccess(state, action);

    case actionTypes.GET_HOME_DATA_TABLE_FAIL:
      return fetchTableDataFail(state, action);

    case actionTypes.GET_VEHICLE_FILTERS_START:
      return fetchVehicleFilterStart(state, action);

    case actionTypes.GET_VEHICLE_FILTERS_DATA:
      return fetchVehicleFilterSuccess(state, action);

    case actionTypes.GET_VEHICLE_FILTERS_FAIL:
      return fetchVehicleFilterFail(state, action);

    case actionTypes.SET_URL:
      return setUrl(state, action);

    case actionTypes.SET_QR_CODE:
      return setQRCode(state, action);

    case actionTypes.SET_FILTERS:
      return setFilters(state, action);

    case actionTypes.SET_SEARCH:
      return setSearch(state, action);

    case actionTypes.SET_ACTIVE:
      return setActive(state, action);

    case actionTypes.SET_SORT_ORDER:
      return setSortOrder(state, action);

    case actionTypes.SET_CURRENT_PAGE:
      return setCurrentPage(state, action);

    default:
      return state;
  }
};

export default vehiclePageReducer;
